module.exports = __webpack_public_path__ + "img/NANO.2951904c.svg";